module.exports = __webpack_public_path__ + "static/media/trash.28f0455d.svg";